var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home container"},[_c('img',{staticClass:"logo",attrs:{"alt":"Salex Logo","src":require("../assets/sx_logo.svg")}}),_c('div',{staticClass:"my-3 has-text-centered is-size-3"},[_vm._v("Image Uploader")]),(_vm.user.isLogged)?_c('UploadMedia'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }